// Simple version of https://www.npmjs.com/package/@16g/react-simple-format

import * as React from "react"
import * as Sanatize from 'sanitize-html';
import parser from 'html-react-parser';
function splitParagraphs(text : string) : string[] {
  const pattern = /([^\n]\n)(?=[^\n])/g;
  return text.replace(/\r\n?/g, '\n').split(/\n\n+/).map(t => (
    pattern.test(t) ? t.replace(pattern, '$1<br/>') : t
  ));
}

type Props = {
  text: string
}
export default (props: Props) : JSX.Element => {
  if (!props.text) {
    return <></>
  }
  const sanitizedText = Sanatize(props.text, { allowedTags: [] } );
  const paragraphs = splitParagraphs(sanitizedText);

  const children = paragraphs.map((p, i) => {
    return <p key={`paragraph-${i}`}>{parser(p)}</p>
  });
  return <div>{children}</div>
}

